import { useTranslation } from "../../context/TranslationContext";
import Button from "../ds/Button";
import EmptyState from "../ds/EmptyState";
import Icon from "../ds/Icon";
import { MySubmissionRow, SubmissionDialogs } from "./SubmissionRows";
import useSubmissionActions from "./useSubmissionActions";
import { APP_FILLED } from "./shared";

const Summary = ({ label, value }) => (
  <div className="flex min-w-0 flex-col gap-space-4 rounded-[22px] bg-bg-inset p-space-16">
    <p className="truncate text-caps-label uppercase text-label-tertiary">{label}</p>
    <p className="truncate text-title-3 text-label-primary">{value}</p>
  </div>
);

/** Figma V4: a creator's work on one campaign, totals on top. */
const MySubmissions = ({ submissions, setSubmissions, refresh, setToast, isDark, onSubmit }) => {
  const { t } = useTranslation();
  const actions = useSubmissionActions({ setToast, refresh, setSubmissions });
  const approved = submissions.filter((row) => row.status === "approved");
  const views = approved.reduce((sum, row) => sum + (row.viewCount || 0), 0);
  const earned = approved.reduce((sum, row) => sum + (row.totalEarned || 0), 0);

  return (
    <section className="flex flex-col gap-space-16">
      <div className="grid grid-cols-1 gap-space-12 min-[600px]:grid-cols-3 min-[600px]:gap-space-24">
        <Summary label={t("campaignFlow.submitted")} value={submissions.length} />
        <Summary label={t("campaignFlow.approvedViews")} value={views.toLocaleString()} />
        <Summary label={t("campaignFlow.earned")} value={`${earned.toFixed(2)} ₾`} />
      </div>
      {submissions.length === 0 ? (
        <div className="flex flex-col items-center rounded-radius-lg bg-bg-raised pb-space-24">
          <EmptyState icon="upload" title={t("campaignFlow.noSubmissionsTitle")} message={t("campaignFlow.noSubmissionsBody")} />
          {onSubmit && (
            <Button size="m" className={APP_FILLED} icon={<Icon name="upload" size={20} />} onClick={onSubmit}>
              {t("campaigns.submitEntry")}
            </Button>
          )}
        </div>
      ) : (
        <ul className="flex flex-col divide-y divide-separator-default rounded-radius-lg bg-bg-raised py-space-8">
          {submissions.map((submission) => (
            <MySubmissionRow key={submission._id} submission={submission} actions={actions} />
          ))}
        </ul>
      )}
      <SubmissionDialogs actions={actions} isDark={isDark} />
    </section>
  );
};

export default MySubmissions;
